<div *ngIf="multiIconQuickLinksData" class="cards col-12 h-100 m-0" style="max-width: 100%">
  <div class="divStyle pointer-events-none h-100">
    <finxone-web-frontend-multi-icon-quick-link
      [multiIconQuickLinksData]="multiIconQuickLinksData"
      [contentStyle]="contentStyle"
      [textContentStyle]="textContentStyle"
      [leftIcon]="this.leftIcon"
      [rightIcon]="this.rightIcon"
      [headerSubheaderTemplate]="this.headerSubheaderTemplate"
      [isAllowedGlobalStyling]="isAllowedGlobalStyling"
      [globalStylingClass]="globalStylingClass"
      [iconStyle]="iconStyle"
    ></finxone-web-frontend-multi-icon-quick-link>
  </div>
</div>
